export enum OutboundEventName {
  Ready = 'ready',
  SizeChange = 'sizeChange',
  Change = 'change',
  Crash = 'crash',
}
